export default __webpack_public_path__ + "static/media/otherDetails.cbdda832.svg";